import React, { useEffect, useState } from "react";
import { Element } from "react-scroll";
import Image from "../../assets/vector/community-image.png";
import "./FirstPara.css";

function FirstPara() {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("about");
      if (!section) return;

      const sectionTop = section.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      setShowContent(sectionTop < windowHeight * 0.75);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on load

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="firstpara-section">
      <div className="firstpara-title">
        <h5 className="firstpara-subheading">
          Fostering Innovation and Collective Wisdom for a Brighter Future
        </h5>
      </div>

      <Element
        id="about"
        className={`firstpara-content ${showContent ? "show" : ""}`}
      >
        <div className="firstpara-text">
          <p>
            IQApex Labs is mainly an IT service and software development firm.
            We are focused on web & mobile app development, blockchain
            development, digital marketing etc. We have already worked on a
            variety range of services almost in every domain. Apart from these
            services, we are also known for our research-based product
            development expertise.
          </p>
        </div>

        <div className="firstpara-image">
          <img src={Image} alt="IQApex Labs Community & Innovation" />
        </div>
      </Element>
    </section>
  );
}

export default FirstPara;
